import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import { useEffect, useState } from "react";
import { useContext } from "react"
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from "../../services/api";
import CustomToolbar from '../../components/grid/CustomToolbar'
import SL_Button from '../../components/buttons/Button'
import protocol_grid_columns from "./grid_columns/protocol_grid_columns";
import { useNavigate } from "react-router-dom";
// import ProtocolFilters from './ProtocolFilters'
import ELanguages from "../../enums/ELanguages";
import { displayMessage } from "../../services/helper";
import { PlusOutlined, DeleteOutlined, FileSearchOutlined } from '@ant-design/icons'
import { DatePicker, Form, Input, Modal, Popconfirm, Switch, Checkbox, Row, Col, Card, Space, Select } from "antd";
import { FooterTable } from "../../components/grid/FooterTable";
import moment from "moment";
import EDaysOfTheWeek from "../../enums/EDaysOfTheWeek";
import { getLanguageOnLocalstorage } from "../../services/helper";

const {Option} = Select;


export default function ListProtocol() {
    const rowsPerPage = 20
    const initialOffset = 0   

    const {setShowLoading, user, enums, windowHeight, mobile_mode, currentProtocol, setCurrentProtocol} = useContext(GeneralContext)

    const gridRef = useGridApiRef()
    const DataGridProHeight = windowHeight * 0.7
    const [offset, setOffset] = useState(initialOffset)
    const [quantityRows, setQuantityRows] = useState(rowsPerPage)
    const [protocols, setProtocols] = useState([])
    const [haveSomethingSelected, setHaveSomethingSelected] = useState(false)
    const [isModalCreateProtocolVisible, setIsModalCreateProtocolVisible] = useState(false)
    const [isModalUpdateProtocolVisible, setIsModalUpdateProtocolVisible] = useState(false)
    const [currentLanguage, setCurrentLanguage] = useState([])
    const currentLanguageCode = getLanguageOnLocalstorage();
    const navigate = useNavigate();

    useEffect(() => {

        checkUserType()
        const lang = Object.values(ELanguages).find(
            (l) => l.code === +currentLanguageCode 
          );
          setCurrentLanguage(lang);
          loadProtocols(lang);
    }, [])


    const loadProtocols = async (currentFilters, currentOffset = offset) => {
        try {
            setShowLoading(true)
            const payload = Object.keys(currentFilters || {}).length > 0
            ? { ...currentFilters }
            : currentLanguage;          
            const rs = await api.protocols.listProtocols({payload:payload,offset: currentOffset,
                limit: rowsPerPage,})
            gridRef.current.setSelectionModel([])
            setProtocols(rs.data.rows)
            setQuantityRows(rs.data.count)
        } finally {
            setShowLoading(false)
        }
    }

    const checkUserType = () => {
        if (enums) {
            user.user_type != enums?.EUserTypes?.ADMIN?.code && navigate("/")
        }
    }


    const handleRowChange = (e) => {
        setCurrentProtocol(e?.row)
    }

    const renderCustomToolBar = () => {
        return (<CustomToolbar />)
    }

    const navigateToDetailProtocol = () => {
        navigate(`/protocol/detail`)
    }


    const handleOnOpenModalCreateProtocol = () => {
        setIsModalCreateProtocolVisible(true)
    }


    const handleOnDelete = async (data) => {
        try {
            setShowLoading(true)
           await api.protocols.delete(data.id)
            loadProtocols()
        } finally {
            setShowLoading(false)
            alert(displayMessage('DELETE_PROTOCOL_SUCCESS'), 'success')
        }
    }

    const handleWhatIsSelectedInGrid = () => {
        const _controls = []
        gridRef.current.getSelectedRows().forEach((e) => _controls.push(e))
        if (_controls.length > 0) {
            setHaveSomethingSelected(true)
        }
        else {
            setHaveSomethingSelected(false)
        }
    }

    /*Actions */
    const actionCancel = {
        field: 'cancel_action',
        headerName: displayMessage('CANCEL'),
        width: 100,
        sortable: false,
        align: 'center',
        renderCell: (params) => {
            return (
                <div>
                    <Popconfirm
                        zIndex={10001}
                        placement="bottomLeft"
                        title={displayMessage('WARNING_DELETE_PROTOCOL')}
                        onConfirm={() => handleOnDelete(params.row)}
                        okText={displayMessage('YES')}
                        cancelText={displayMessage('NO')}
                        disabled={user?.user_type != enums?.EUserTypes?.ADMIN?.code}
                    >
                        <SL_Button
                            style={{ background: 'red', borderColor: 'pink', color: 'pink', fontWeight: 'bold' }}
                            shape="circle"
                            icon={<DeleteOutlined />}
                            disabled={user?.user_type != enums?.EUserTypes?.ADMIN?.code}
                        >
                        </SL_Button>
                    </Popconfirm>

                </div>
            )
        },
        disableColumnSelector: true
    }

    /* Modals */

    const CreateProtocol = props => {
        const [form] = Form.useForm()
        const [selectedDays, setSelectedDays] = useState([]);
        const daysOfWeek = Object.values(EDaysOfTheWeek ?? {}).map((day)=>{
            return {
              label: day.label,
              value: day.code,
            }
          }) ?? []
          
        const createNewProtocol = async (payload) => {
            setShowLoading(true)

            await api.protocols.create({...payload, scheduleDays: selectedDays}).then(
                rs => {
                    setShowLoading(false)
                    alert(displayMessage('CREATED_PROTOCOL_SUCCESS'), 'success')
                    loadProtocols()
                    setIsModalCreateProtocolVisible(false)
                }
            )
        }
        return (
            <Modal
                title={<div className="text-xl font-bold text-appian-blue">{displayMessage('CREATE_PROTOCOL')} </div>}
                visible={isModalCreateProtocolVisible}
                onCancel={() => setIsModalCreateProtocolVisible(false)}
                centered={true}
                footer={[]}
                width={750}
                style={{ position: 'relative' }}
                bodyStyle={{ maxHeight: windowHeight * 0.8, overflow: 'auto' }}
            >
                <Form
                    form={form}
                    className='w-full flex flex-col gap-2 p-5'
                    onFinish={createNewProtocol}
                    layout="vertical"
                    requiredMark='optional'
                >
                    <div style={{ display: 'flex', flexDirection:'column',  gap: 5, alignItems: 'center' }}>
                        <Form.Item
                            label={displayMessage('NAME')}
                            name="name"
                            className={`w-full flex`}
                            style={{ flex: 1 }}
                            rules={[{ required: true, message: displayMessage('NAME_IS_REQUIRED') }]}
                        >
                            <Input
                                type="description"
                                size='large'
                                placeholder={displayMessage('ENTER_NAME')}
                            />
                        </Form.Item>
                        <Form.Item
                            label={displayMessage('DESCRIPTION')}
                            name="description"
                            className={`w-full flex`}
                            style={{ flex: 1 }}
                            
                        >
                            <Input
                                type="description"
                                size='large'
                                placeholder={displayMessage('ENTER_DESCRIPTION')}
                            />
                        </Form.Item>
                        <Form.Item
                    label={displayMessage('LANGUAGE')}
                    name="language"
                    className={`w-full flex`}
                    rules={[
                        { required: true, message: displayMessage('LANGUAGE_MANDATORY') },
                      ]}
                >
                    <Select
                        type="text"
                        size='large'
                        allowClear
                        placeholder={displayMessage('LANGUAGE')}

                    >
               {Object.values(ELanguages).map((type) => (
    <Option key={type.code} value={type.code}>
        {type.description}
    </Option>
))}
                    </Select>
                </Form.Item>
                        <Form.Item>      
                        </Form.Item>    
                        <Form.Item
            name="scheduleDays"
            label={
              <span className="text-base font-medium">
                {displayMessage("SCHEDULE_DAYS")}
              </span>
            }
          >
            <Card className="rounded-xl border border-gray-200 bg-gray-50 p-5">
              <Row gutter={[16, 12]}>
                {daysOfWeek.map((day) => (
                  <Col xs={24} sm={12} key={day.value}>
                    <div
                      className={`p-3 px-4 rounded-lg border-2 cursor-pointer transition-all duration-300 flex items-center gap-2 ${
                        selectedDays.includes(day.value)
                          ? "border-blue-500 bg-blue-50"
                          : "border-gray-200 bg-white"
                      }`}
                      onClick={() => {
                        setSelectedDays((prev) =>
                          prev.includes(day.value)
                            ? prev.filter((val) => val !== day.value)
                            : [...prev, day.value]
                        );
                      }}
                    >
                      <Checkbox
                        value={day.value}
                        checked={selectedDays.includes(day.value)}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setSelectedDays((prev) =>
                            checked
                              ? [...prev, day.value]
                              : prev.filter((val) => val !== day.value)
                          );
                        }}
                        className="pointer-events-none"
                      />
                      <span
                        className={`text-sm ${
                          selectedDays.includes(day.value)
                            ? "font-medium text-blue-500"
                            : "font-normal text-gray-800"
                        }`}
                      >
                        {day.label}
                      </span>
                    </div>
                  </Col>
                ))}
              </Row>
            </Card>
          </Form.Item>
                    </div>
                    <SL_Button
                        type="primary"
                        size='large'
                        htmlType="submit"
                        className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                    >
                        {displayMessage('CREATE_PROTOCOL')}
                    </SL_Button>

                </Form>
            </Modal>
        )
    }


    const EditProtocol = props => {
        const [form] = Form.useForm()
        const [myProtocol, setMyProtocol] = useState(null)
        const [edit_mode, setEditMode] = useState(false)

        function loadMyProtocol() {
            setShowLoading(true)

            api.holiday.find(currentProtocol.id)
                .then(
                    rs => {
                        rs.data.holiday_date = moment(rs.data.holiday_date)
                        setMyProtocol(rs.data)
                        form.setFieldsValue(rs.data)
                    }
                )
                .finally(
                    setShowLoading(false)
                )
        }

        useEffect(() => {
            loadMyProtocol()
        }, [])

        const updateNewProtocol = payload => {
            setShowLoading(true)
            api.holiday.update(currentProtocol.id, payload).then(
                rs => {
                    setShowLoading(false)
                    alert(displayMessage('DEATAIL_HOLIDAY_TITLE'), 'success')
                    loadProtocols()
                    setIsModalUpdateProtocolVisible(false)
                }
            )
        }

        const handleSetEditMode = () => {
            setEditMode(!edit_mode)
        }
        return (
            <Modal
                title={<div className="text-xl font-bold text-appian-blue">{displayMessage('DEATAIL_HOLIDAY_TITLE')} </div>}
                visible={isModalUpdateProtocolVisible}
                onCancel={() => setIsModalUpdateProtocolVisible(false)}
                centered={true}
                footer={[]}
                width={750}
                style={{ position: 'relative' }}
                bodyStyle={{ maxHeight: windowHeight * 0.8, overflow: 'auto' }}
            >
                <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end', alignItems: 'center' }}>
                    <Switch
                        onChange={handleSetEditMode}
                        style={{ height: 30, width: mobile_mode ? '100%' : null, maxWidth: 180, marginTop: mobile_mode ? 10 : 0 }}
                        unCheckedChildren={displayMessage('EDIT_HOLIDAY')}
                        checkedChildren={displayMessage('CANCEL')}
                        disabled={user?.user_type != enums?.EUserTypes?.ADMIN?.code}
                    />
                </div>
                <Form
                    form={form}
                    className='w-full flex flex-col gap-2 p-5'
                    onFinish={updateNewProtocol}
                    layout="vertical"
                    requiredMark='optional'
                >
                    <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', gap: 5, alignItems: 'center' }}>
                        <Form.Item
                            label={displayMessage('DESCRIPTION')}
                            name="description"
                            className={`w-full flex`}
                            style={{ flex: 1 }}
                            rules={[
                                { required: true },
                            ]}
                        >
                            <Input
                                type="description"
                                size='large'
                                placeholder={displayMessage('ENTER_DESCRIPTION')}
                                disabled={!edit_mode}
                            />
                        </Form.Item>

                        <Form.Item
                            label={displayMessage("HOLIDAYS_DATE")}
                            name="holiday_date"
                            className={`w-full flex`}
                            style={{ display: 'flex', flex: 1, maxWidth: 200, marginLeft: mobile_mode ? '' : 10, justifyContent: mobile_mode ? '' : 'flex-end' }}
                            rules={[
                                { required: true },
                            ]}
                        >
                            <DatePicker
                                style={{ display: 'flex', flex: 1 }}
                                size='large'
                                disabled={!edit_mode}
                            />
                        </Form.Item>
                    </div>
                    <SL_Button
                        type="primary"
                        size='large'
                        htmlType="submit"
                        className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                        disabled={!edit_mode}
                    >
                        {displayMessage('UPDATE_HOLIDAY')}
                    </SL_Button>

                </Form>
            </Modal>
        )
    }




    return (
        <>
            {
                isModalCreateProtocolVisible
                &&
                <CreateProtocol />
            }

            {
                isModalUpdateProtocolVisible
                &&
                <EditProtocol />
            }
            {/* <ProtocolFilters handleOnSearchSatusHistory={loadProtocols} /> */}

            <div className='flex flex-col w-full'>
                <div className={`flex flex-1 justify-between p-2 bg-appian-blue gap-1 ${mobile_mode ? `flex-col` : `flex-row`} `}>
                    <span className='self-center text-white flex-1 text-center font-medium'>{displayMessage('PROTOCOLS_LIST')}</span>
                    <div className={`flex gap-1 ${mobile_mode ? `flex-col` : `flex-row`}`} >
                    <Select
                className={`w-full flex`}
                placeholder={displayMessage("SELECT_OPTION")}
                value={currentLanguage?.code}
                onChange={(value) => {
                    setCurrentLanguage(Object.values(ELanguages).find(l => l.code === value))
                    loadProtocols(Object.values(ELanguages).find(l => l.code === value))
                } } 
              >
                {Object.values(ELanguages).map((type) => (
                  <Option value={type?.code}>{type.description}</Option>
                ))}
              </Select>
                        <SL_Button
                            type='default'
                            className='items-center w-30 flex'
                            disabled={!haveSomethingSelected}
                            style={{ color: !haveSomethingSelected ? 'grey' : null }}
                            onClick={navigateToDetailProtocol}
                            icon={<FileSearchOutlined className={`text-base ${haveSomethingSelected ? 'text-green-900' : ''}`} />}
                        >
                            {displayMessage('DETAIL_PROTOCOL')}
                        </SL_Button>
                    </div>
                    <div className={`flex gap-1 ${mobile_mode ? `flex-col` : `flex-row`}`} >
                        <SL_Button
                            type='default'
                            className='items-center w-30 flex'
                            onClick={handleOnOpenModalCreateProtocol}
                            icon={<PlusOutlined className={`text-base text-green-900`} />}
                        >
                            {displayMessage('CREATE_PROTOCOL')}
                        </SL_Button>
                    </div>
                </div>

                <div style={{ height: DataGridProHeight, minHeight: 300 }} >
                    <DataGridPro
                        rows={protocols}
                        apiRef={gridRef}
                        style={{ height: '100%' }}
                        columns={protocol_grid_columns.concat(actionCancel)}
                        pagination
                        pageSize={100}
                        components={{
                            Toolbar: renderCustomToolBar,
                            Footer: () => (
                                <>
                                  <FooterTable
                                    offset={offset}
                                    rowsPerPage={rowsPerPage}
                                    quantityRows={quantityRows}
                                    setOffset={setOffset}
                                    functionOnChange={loadProtocols}
                                  />
                                </>
                              ),
                        }}
                        onRowClick={handleRowChange}
                        density="compact"
                        disableMultipleSelection
                        onSelectionModelChange={() => handleWhatIsSelectedInGrid()}
                    />

                </div>
            </div>

        </>
    )
}